export * from './dienstplanQuery.service';
import { DienstplanQueryService } from './dienstplanQuery.service';
export const APIS = [DienstplanQueryService];
